import styled from 'styled-components';

export const LogoWrapper = styled.div<{ $collapsed?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 27px;
  padding-bottom: ${({ $collapsed }) => ($collapsed ? '20px' : '28px')};
`;

export const LogoMark = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
